export enum LiveEventGameAIPrompt {
  GAME_CUSTOM_PROMPT = 'CUSTOM_PROMPT',
  GAME_STRATEGY_CHANGES_14 = 'GAME_STRATEGY_CHANGES_14',
}
